import React from 'react';
import { Table, Col, Row } from 'react-bootstrap';
import { formatPercent } from '../Helpers';

const Summary = ({ 
  quarterInfo, 
  updateSummaryInput, 
  updateDbQuarterSummary, 
  activePortfolioId 
}) => {

  function onInputChange(e) {
    updateSummaryInput({
      value: e.target.value.replace(/%/g, ''),
      name: e.target.name
    });

    updateDbQuarterSummary({
      value: e.target.value.replace(/%/g, ''),
      name: e.target.name,
      activePortfolioId: activePortfolioId
    });
  }

  return (
    <Row>
      <Col md={12}>
        <Table bordered responsive id="dashboard-summary">
          <thead>
            <tr>
              <th></th>
              <th>SG</th>
              <th>SPX</th>
              <th>DIFF</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1st Quarter</td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SGqtr1 + '%' } name="SGqtr1" 
                  onChange={(e) => onInputChange(e)} />
              </td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SPXqtr1 + '%' } name="SPXqtr1" 
                  onChange={(e) => onInputChange(e)} />                
              </td>
              <td>{ formatPercent(quarterInfo.qtr1Diff) }</td>
            </tr>
            <tr>
              <td>2nd Quarter</td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SGqtr2 + '%' } name="SGqtr2" 
                  onChange={(e) => onInputChange(e)} />                  
              </td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SPXqtr2 + '%' } name="SPXqtr2" 
                  onChange={(e) => onInputChange(e)} />                 
              </td>
              <td>{ formatPercent(quarterInfo.qtr2Diff) }</td>
            </tr>
            <tr>
              <td>3rd Quarter</td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SGqtr3 + '%' } name="SGqtr3" 
                  onChange={(e) => onInputChange(e)} />                
              </td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SPXqtr3 + '%' } name="SPXqtr3" 
                  onChange={(e) => onInputChange(e)} />                 
              </td>
              <td>{ formatPercent(quarterInfo.qtr3Diff) }</td>
            </tr>
            <tr>
              <td>4th Quarter</td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SGqtr4 + '%' } name="SGqtr4" 
                  onChange={(e) => onInputChange(e)} />                  
              </td>
              <td style={{ padding: 0 }}>
                <input 
                  className="cell-input" 
                  value={ quarterInfo.SPXqtr4 + '%' } name="SPXqtr4" 
                  onChange={(e) => onInputChange(e)} />              
              </td>
              <td>{ formatPercent(quarterInfo.qtr4Diff) }</td>
            </tr>
            <tr>
              <td>Return</td>
              <td>{ formatPercent(quarterInfo.SGTotal) }</td>
              <td>{ formatPercent(quarterInfo.SPXTotal) }</td>
              <td>{ formatPercent(quarterInfo.totalDiff) }</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  );
}

export default Summary;